(() => {
let timer,sequence=0;
const nativeFetch=window.fetch;
const refresh=()=>{clearTimeout(timer);timer=setTimeout(async()=>{
const current=++sequence;
try{
const response=await nativeFetch((window.Shopify?.routes?.root||'/')+'cart?section_id=nl-live-food-offer',{credentials:'same-origin',cache:'no-store'});
if(!response.ok)return;
const doc=new DOMParser().parseFromString(await response.text(),'text/html');
const offers=doc.querySelectorAll('.nl-live-food-offer');
if(current!==sequence)return;
document.querySelectorAll('[data-nl-live-food-offer]').forEach(host=>{host.replaceChildren();offers.forEach(offer=>{
const copy=offer.cloneNode(true);
if(host.hasAttribute('data-nl-product-collections')&&!host.closest('[data-atc-banner]')){
const ids=host.dataset.nlProductCollections.split(',');
const map={live_food:['414776721636'],roses:['414784094436'],aquatic_plants:['414776066276','414776393956'],fish:['414783111396','414783144164','414783176932']};
if(!map[copy.dataset.offerGroup]?.some(id=>ids.includes(id)))copy.classList.add('nl-offer-other');
}
host.append(copy);
});});
}catch{}
},120);};
const isMutation=url=>/\/cart\/(add|change|update|clear)(\.js|\.json)?([?#]|$)/.test(String(url));
window.fetch=function(input,options){const result=nativeFetch.apply(this,arguments);if(isMutation(typeof input==='string'?input:input?.url))result.then(r=>{if(r.ok)refresh();},()=>{});return result;};
const open=XMLHttpRequest.prototype.open;
XMLHttpRequest.prototype.open=function(method,url){if(isMutation(url))this.addEventListener('load',()=>{if(this.status>=200&&this.status<300)refresh();},{once:true});return open.apply(this,arguments);};
document.addEventListener('cart:updated',refresh);
document.addEventListener('cart:refresh',refresh);
})();
(() => {
const mobile=()=>true;
const panel=()=>[...document.querySelectorAll('.atc-banner--container')].find(el=>el.getClientRects().length&&getComputedStyle(el).visibility!=='hidden'&&getComputedStyle(el).opacity!=='0');
const close=()=>{const box=panel();if(box)box.querySelector('[data-atc-banner-close]')?.click();};
document.addEventListener('click',event=>{if(event.target.closest('.nl-atc-continue'))close();});
let touchY=null, scrollY=null, lastPanel=null;
document.addEventListener('touchstart',event=>{if(mobile()&&panel())touchY=event.touches[0].clientY;else touchY=null;},{passive:true});
document.addEventListener('touchmove',event=>{if(mobile()&&touchY!==null&&Math.abs(event.touches[0].clientY-touchY)>24){close();touchY=null;}},{passive:true});
window.addEventListener('scroll',()=>{if(!mobile())return;const box=panel();if(!box){lastPanel=null;scrollY=null;return;}if(lastPanel!==box||scrollY===null){lastPanel=box;scrollY=window.scrollY;return;}if(Math.abs(window.scrollY-scrollY)>20){close();lastPanel=null;scrollY=null;}},{passive:true});
document.addEventListener('wheel',()=>{if(mobile())close();},{passive:true});
})();

(()=>{
if(window.nlStockRulesReady)return;window.nlStockRulesReady=true;
const init=main=>{
 if(main.dataset.nlStockReady)return;
 const config=main.querySelector('[data-nl-stock-variants]');if(!config)return;
 main.dataset.nlStockReady='true';
 const variants=JSON.parse(config.textContent);
 const update=()=>{
  const selection=main.querySelector('variant-selection');
  const id=selection?.getAttribute('variant')||main.querySelector('form[action*="/cart/add"] [name="id"]')?.value||main.dataset.nlInitialVariant;
  const v=variants[id],out=!!v?.tracked&&v.quantity<=0;
  main.dataset.nlInStock=String(!!v?.available&&!out);
  const notify=main.querySelector('[data-nl-notify]');if(notify)notify.hidden=!(out&&!v?.available);
  const preorder=main.querySelector("[data-nl-quick-preorder]");if(preorder)preorder.hidden=!(out&&v?.available);
 };
 main.addEventListener('change',()=>setTimeout(update,0));
 const selection=main.querySelector('variant-selection');
 if(selection)new MutationObserver(update).observe(selection,{attributes:true,attributeFilter:['variant']});
 update();
};
const start=()=>document.querySelectorAll('.product-main').forEach(init);
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start);else start();
document.addEventListener('shopify:section:load',start);
new MutationObserver(records=>{if(records.some(record=>[...record.addedNodes].some(node=>node.nodeType===1&&(node.matches?.('.product-main')||node.querySelector?.('.product-main')))))start();}).observe(document.documentElement,{childList:true,subtree:true});
})();
(()=>{
const sync=event=>{const main=event.target.closest?.('[data-nl-florist-quick]');if(!main)return;setTimeout(()=>{const link=main.querySelector('[data-nlfq-continue]');const selection=main.querySelector('variant-selection');const id=selection?.getAttribute('variant')||main.querySelector('[name="id"]')?.value;if(link&&id&&/^\d+$/.test(id))link.href=link.dataset.nlfqUrl+'?variant='+encodeURIComponent(id);},0);};
document.addEventListener('change',sync);
})();

(()=>{
function check(form,event){
 if(!form?.matches('.nl-florist-date-form')||form.querySelector('[data-nlfq-continue]'))return;
 const main=form.closest('.product-main');
 const date=main?.querySelector('.product-app input[placeholder="DD/MM/YYYY"]:not([type="hidden"])');
 const chosen=date?.value.trim();
 const error=form.querySelector('[data-nlfq-date-error]');
 if(chosen){if(error)error.hidden=true;return;}
 event.preventDefault();event.stopImmediatePropagation();
 if(error){error.hidden=false;error.scrollIntoView({behavior:'smooth',block:'center'});}
 date?.focus();
}
document.addEventListener('click',event=>{const button=event.target.closest?.('[data-product-atc]');if(button)check(button.closest('form'),event);},true);
document.addEventListener('submit',event=>check(event.target,event),true);
document.addEventListener('input',event=>{if(event.target.matches('.product-app input[placeholder="DD/MM/YYYY"]:not([type="hidden"])')&&event.target.value.trim()){const error=event.target.closest('.product-main')?.querySelector('[data-nlfq-date-error]');if(error)error.hidden=true;}});
})();

(()=>{
function dateState(){
 document.querySelectorAll('.nl-florist-date-form').forEach(form=>{
  if(form.querySelector('[data-nlfq-continue]'))return;
  const main=form.closest('.product-main'),button=form.querySelector('[data-product-atc]');
  if(!main||!button)return;
  const date=main.querySelector('.product-app input[placeholder="DD/MM/YYYY"]:not([type="hidden"])');
  const chosen=!!date?.value.trim();
  let available=true;
  const config=main.querySelector('[data-nl-stock-variants]');
  const id=main.querySelector('variant-selection')?.getAttribute('variant')||form.querySelector('[name="id"]')?.value||main.dataset.nlInitialVariant;
  if(config){try{available=JSON.parse(config.textContent)[id]?.available!==false;}catch{}}
  button.disabled=!chosen||!available;
  const error=form.querySelector('[data-nlfq-date-error]');if(error)error.hidden=chosen;
 });
}
dateState();setInterval(dateState,500);
})();
